import { useEffect, useState, type RefObject } from "react";

/** Decorative motion runs only while visible and explicitly permitted by the OS. */
export function useBannerActivity(ref: RefObject<HTMLElement | null>) {
  const [active, setActive] = useState(() => !document.hidden && !matchMedia("(prefers-reduced-motion: reduce)").matches);
  useEffect(() => {
    const motion = matchMedia("(prefers-reduced-motion: reduce)");
    let visible = false;
    const update = () => setActive(visible && !document.hidden && !motion.matches);
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry?.isIntersecting ?? false;
      update();
    });
    if (ref.current) observer.observe(ref.current);
    document.addEventListener("visibilitychange", update);
    motion.addEventListener("change", update);
    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", update);
      motion.removeEventListener("change", update);
    };
  }, [ref]);
  return active;
}
